import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import logoblack from 'src/assets/product-config/logo-black.png'
import { DefaultLabel } from 'src/pages/receipt/PDF'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import transactionLabel from 'src/utils/transactionLabel'

export const PixKey: FC<{ data: any; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const navigate = useNavigate()

  if (!data?.type?.toLowerCase().includes('pix')) {
    navigate('/extract')
    return null
  }
  console.log(data)
  const user = data?.user
  const label = transactionLabel(data)
  const isIncoming = data.direction === 'in'
  const payer = data?.data?.data?.payer || {}
  const bank = payer.bank || {}
  const amount = data.value || data?.data?.data?.value || data.amount
  const createdAt = data.created_at || new Date().toISOString()

  const city = data?.data?.receiver?.city
  const txId = data?.data?.txid

  const end2end = data?.data?.transfer?.pix_end2end_id
  console.log(data?.data)
  return (
    <>
      <div className="w-full h-16 flex px-10 items-center bg-[#191919]">
        <span className="text-white text-xl font-bold">{label}</span>
      </div>
      <div className="w-full flex justify-center">
        <img src={logoblack} alt="Logo Vilapay Invest" className="w-52 h-52" />
      </div>
      <div className="flex w-full justify-between p-10">
        <div>
          <p className="text-[#191919] text-5xl font-bold">
            R$ {toLocaleAmount(amount)}
          </p>
        </div>
        <span className="font-bold text-lg">{dateToLine(createdAt)}</span>
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Pagador
        </span>
        {isIncoming ? (
          <>
            <DefaultLabel title="NOME" value={payer.name || 'Desconhecido'} />
            <DefaultLabel
              title="Documento"
              value={documentFormatted(payer.document || '')}
            />
            <DefaultLabel title="INSTITUIÇÃO" value={bank.name || 'Symbank'} />
            <div className="flex w-[50%] mt-2 justify-between items-center">
              <DefaultLabel
                size="md"
                title="AG"
                value={payer.agency || 'N/A'}
              />
              <DefaultLabel
                size="md"
                title="CONTA"
                value={`${payer.account || 'N/A'} - ${
                  payer.account_digit || 'N/A'
                }`}
              />
            </div>
          </>
        ) : (
          <>
            <DefaultLabel
              title="NOME"
              value={
                user?.name || data?.data?.beneficiaryName || 'Desconhecido'
              }
            />
            <DefaultLabel
              title="Documento"
              value={documentFormatted(user?.document || '')}
            />
            <DefaultLabel title="INSTITUIÇÃO" value={'Symbank'} />
          </>
        )}
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Favorecido
        </span>
        {!isIncoming ? (
          <>
            <DefaultLabel
              title="NOME"
              value={
                payer.name || data?.data?.beneficiaryName || 'Desconhecido'
              }
            />
            <DefaultLabel
              title="Documento"
              value={documentFormatted(payer.document || '')}
            />
            {bank.name && (
              <DefaultLabel
                title="INSTITUIÇÃO"
                value={bank.name || 'Symbank'}
              />
            )}

            {(payer.agency || payer.account) && (
              <div className="flex w-[50%] mt-2 justify-between items-center">
                {payer.agency && (
                  <DefaultLabel
                    size="md"
                    title="AG"
                    value={payer.agency || 'N/A'}
                  />
                )}
                {payer.account && (
                  <DefaultLabel
                    size="md"
                    title="CONTA"
                    value={`${payer.account || 'N/A'} - ${
                      payer.account_digit || 'N/A'
                    }`}
                  />
                )}
              </div>
            )}
            {city && <DefaultLabel size="md" title="Cidade" value={city} />}
            {txId && (
              <DefaultLabel size="md" title="ID da Transação" value={txId} />
            )}
          </>
        ) : (
          <>
            <DefaultLabel title="NOME" value={user?.name || 'Desconhecido'} />
            <DefaultLabel
              title="Documento"
              value={documentFormatted(user?.document || '')}
            />
            <DefaultLabel title="INSTITUIÇÃO" value={'Symbank'} />
          </>
        )}
        {end2end && <DefaultLabel title="End2End" value={end2end} />}
      </div>
    </>
  )
}
